import * as Bowser from "bowser";
import axios from 'axios';

export const Role = {
    SPEAKER: "speaker",
    EMCEE: "emcee",
    PARTICIPANT: "participant",
};

export const accurateInterval = (func, interval, opts) => {
    if (!opts) opts = {};

    let clear, nextAt, timeout, wrapper, now;

    now = new Date().getTime();

    nextAt = now;

    if (opts.aligned) {
        nextAt += interval - (now % interval);
    }

    timeout = null;

    wrapper = () => {
        let scheduledTime = nextAt;
        nextAt += interval;
        timeout = setTimeout(wrapper, nextAt - new Date().getTime());
        func(scheduledTime);
    };

    clear = () => clearTimeout(timeout);

    timeout = setTimeout(wrapper, nextAt - new Date().getTime());

    return {
        clear: clear
    };
}

export const browser = Bowser.getParser(window.navigator.userAgent);

export const closeWindow = () => {
    const isNewWindow = window.opener || history.length <= 1
    isNewWindow ? window.close() : history.back();
}

export const serverTime = async () => {
    const serverTimeData = await axios.get('https://worldtimeapi.org/api/timezone/Asia/Seoul');
    return serverTimeData.data.datetime;
}

export const windowUnloadEvent = e => {
    // e.preventDefault();
    // e.returnValue = '';
    window.localStorage.removeItem('refreshToken');
}